import { storeList } from '@/api/domain/shop'
import { operateMaxShowLength } from '@/store/dict/config'

export const configDataFn = (params) => {
  const {
    judgePermission,
    handleToStoreDetail,
    handleEditStore,
    handleToGoodsList,
    showStoreQRCode,
  } = params
  const configData = {
    formData: {
      formProps: {
        ref: 'searchForm',
      },
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '门店名称',
            prop: 'name',
          },
          elConfig: {
            clearable: true,
            maxlength: 20,
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '所在城市',
            prop: 'cityCode',
          },
          elConfig: {
            placeholder: '请输入',
            clearable: true,
            filterable: true,
            options: {
              label: 'city',
              value: 'adcode',
              list: [],
            },
          },
        },
      ],
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            label: '门店ID',
            prop: 'id',
            width: 120,
          },
          render: ({ row }) => {
            if (!judgePermission('company_store_detail')) return row.id
            return <span class="a-hover-link" onClick={() => handleToStoreDetail(row)}>{row.id || '--'}</span>
          },
        },
        {
          name: 'name',
          columnProps: {
            label: '门店名称',
            prop: 'name',
          },
        },
        {
          name: 'cityName',
          columnProps: {
            label: '所在城市',
            prop: 'cityName',
          },
        },
        {
          name: 'address',
          columnProps: {
            label: '详细地址',
            prop: 'address',
            minWidth: 280,
          },
        },
        {
          name: 'businessHours',
          columnProps: {
            label: '营业时间',
            prop: 'businessHours',
            width: 120,
          },
        },
        {
          name: 'onlineGoodsCount',
          columnProps: {
            label: '上架中商品数',
            prop: 'onlineGoodsCount',
            width: 110,
          },
          render: ({ row }) => {
            const { onlineGoodsCount } = row
            if (!onlineGoodsCount) return 0
            return <span class="a-hover-link" onClick={() => handleToGoodsList(row)}>{onlineGoodsCount}</span>
          },
        },
        {
          name: 'followingClueCount',
          columnProps: {
            label: '跟进中线索数',
            prop: 'followingClueCount',
            width: 110,
          },
          render: ({ row }) => {
            const { followingClueCount } = row
            if (!followingClueCount) return 0
            return followingClueCount
          },
        },
        {
          name: 'createTime',
          columnProps: {
            label: '创建时间',
            prop: 'createTime',
            width: 180,
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            prop: 'operate',
            fixed: 'right',
            width: 120,
          },
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            const arr = [
              {
                label: '编辑',
                permission: judgePermission('company_handle_store'),
                action: () => handleEditStore(row),
              },
              {
                label: '门店码',
                action: () => showStoreQRCode(row),
              },
            ]
            return arr
          },
          type: 'operate',
        },
      ],
      apiFn: storeList,
    },
    isShowDepartment: false,
  }
  return configData
}
